import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { openModal } from "../redux/features/modalSlice";
import a2only from "../assets/image/a2only.png";
import Cookies from "js-cookie";
// import user from "../assets/images/";
// import logo from "../assets/images/logo.png";
import { FiCheck, FiInbox } from "react-icons/fi";
import { logoutAdmin } from "../redux/services/authService/authApi";
import { TfiMenu } from "react-icons/tfi";
import { errorToast, successToast } from "../Utils/toast";
import { getUserRole, getAdminData } from "../Utils/role";
import { useNavigate } from "react-router-dom";
import {
  FiBell,
  FiUser,
  FiSettings,
  FiLogOut,
  // FaRupeeSign 
  FiZap
} from "react-icons/fi";
import { FaRupeeSign } from "react-icons/fa";

import {
  getDropdownNotifications,
  getUnreadCount,
  markNotificationRead,
  markAllNotificationsRead,
} from "../redux/services/notificatrion/notification.Services";
import { getVendorAllPlans } from "../redux/services/SubscriptionServices/Subscription.Services";

function Header({ onToggleSidebar }) {
  const admin = useSelector((state) => state.auth);
  const [subscription, setSubscription] = useState([]);
  const [totalSubscriptions, setTotalSubscriptions] = useState(0);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [page, setPage] = useState(1);
  const [dropdown, setDropdown] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const notifRef = useRef(null);
  const [activePlan, setActivePlan] = useState({
    planName: "No Active Plan",
    totalLeads: 0,
    usedLeads: 0,
    remainingLeads: 0,
    balance: 0,
  });
  const dispatch = useDispatch();
  const profile = () => {
    setDropdown((prev) => !prev);
  };
  const navigate = useNavigate();
  const role = getUserRole();
  const adminData = getAdminData();
  const dropdownRef = useRef(null);


  const fetchNotifications = async () => {
    try {
      const [listRes, countRes] = await Promise.all([
        getDropdownNotifications({ page: 1, per_page: 5 }),
        getUnreadCount({}),
      ]);
      const list = listRes?.data?.notifications || listRes?.data || [];
      const count = countRes?.data?.count || countRes?.count || countRes?.data || 0;
      setNotifications(Array.isArray(list) ? list.slice(0, 5) : []);
      setUnreadCount(typeof count === "number" ? count : 0);
    } catch (err) { console.log(err); }
  };
const fetchSubscriptionList = async () => {
  try {
    const res = await getVendorAllPlans();
    const data = res?.data || res;

    const subscriptions = Array.isArray(data?.subscriptions)
      ? data.subscriptions
      : [];

    setSubscription(subscriptions);
    setTotalSubscriptions(data?.total_subscriptions ?? subscriptions.length);
    setTotalAmountPaid(data?.total_amount_paid ?? 0);

    // ✅ Sirf active plan nikaalo
    const activeSub =
      subscriptions.find((s) => s.status === "active") || null;

    if (activeSub) {
      // Total limit = active plan ka ai_call_limit
      const totalLimit =
        activeSub?.usage?.ai_calls?.limit ??
        activeSub?.ai_call_limit ??
        0;

      // Used
      const usedLeads = activeSub?.usage?.ai_calls?.used ?? 0;

      // Remaining — backend ka `remaining` 0 hai (buggy),
      // isliye khud calculate kar rahe hain
      const remainingLeads = Math.max(totalLimit - usedLeads, 0);

      setActivePlan({
        planName:
          activeSub?.plan_name ||
          activeSub?.module_name ||
          "Active Plan",
        totalLeads: totalLimit,       // 5000
        usedLeads: usedLeads,         // 0
        remainingLeads: remainingLeads, // 5000
        balance: Number(activeSub?.amount_paid) || 0, // ₹799
      });
    } else {
      setActivePlan({
        planName: "No Active Plan",
        totalLeads: 0,
        usedLeads: 0,
        remainingLeads: 0,
        balance: 0,
      });
    }
  } catch (error) {
    console.log("fetchSubscriptionList error:", error);
    errorToast("Failed to load your plans");
    setSubscription([]);
    setActivePlan({
      planName: "No Active Plan",
      totalLeads: 0,
      usedLeads: 0,
      remainingLeads: 0,
      balance: 0,
    });
  }
};
  useEffect(() => {
    fetchSubscriptionList(1);
  }, []);
  // useEffect(() => {
  //   fetchNotifications();
  //   const interval = setInterval(fetchNotifications, 30000);
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    const initCount = async () => {
      try {
        const countRes = await getUnreadCount({});
        const count = countRes?.data?.count || countRes?.count || countRes?.data || 0;
        setUnreadCount(typeof count === "number" ? count : 0);
      } catch (err) {
        console.log(err);
      }
    };
    initCount();
  }, []);
  const handleMarkRead = async (id, e) => {
    e?.stopPropagation();
    try {
      const paylaod = {
        notification_id: id
      }
      await markNotificationRead(paylaod);
      fetchNotifications();
    } catch { }
  };

  const handleMarkAll = async (e) => {
    e?.stopPropagation();
    try { await markAllNotificationsRead(); fetchNotifications(); } catch { }
  };
  const handleLogout = async () => {
    try {
      await logoutAdmin();
      // Cookies.remove("adminToken");
      localStorage.removeItem("adminToken");
      localStorage.clear();
      sessionStorage.clear();
      successToast("Logged out successfully");
      navigate("/login", { replace: true });
    } catch (error) {
      console.log(error);
      // Cookies.remove("adminToken");
      localStorage.removeItem("adminToken");
      localStorage.clear();
      sessionStorage.clear();

      errorToast("Logout failed but session cleared");

      navigate("/login", { replace: true });
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className='header' id='header'>
      <div className="d-flex justify-content-between align-items-center px-2 w-100">
        <div className="d-flex align-items-center gap-3">
          <div className="togglebutton">
            <TfiMenu onClick={onToggleSidebar} />
          </div>

        </div>
        <div className="linksmode d-flex align-items-center gap-2">
          {/* <div className="header-icon-btn">
            <FiBell />
          </div> */}
            <div
            className="ai-wallet-widget"
            onClick={() => navigate("/my-subscriptions")}
            // title={`${activePlan.planName} — View Subscription Details`}
          >
            {/* Top Title Row */}
            <div className="wallet-top-row">
              <FiZap className="wallet-zap-icon" />
              <span className="wallet-title">AI CALLING CREDITS</span>
            </div>
            <div className="wallet-data-row">
              {/* <div className="wallet-bal">
                <FaRupeeSign size={12} />
                <span>{activePlan.balance || 0}</span>
              </div> */}

              <div className="wallet-sep"></div>
              <div className="wallet-usage-box">
                <div className="wallet-usage-text">
                  <span className="text-white">{activePlan.usedLeads || 0}</span>
                  <span className="text-muted">/ {activePlan.totalLeads || 0}</span>
                </div>
                <div className="wallet-progress-bg">
                  <div
                    className="wallet-progress-fill"
                    style={{
                      width: `${
                        activePlan.totalLeads > 0
                          ? Math.min(
                              (activePlan.usedLeads / activePlan.totalLeads) * 100,
                              100
                            )
                          : 0
                      }%`,
                    }}
                  ></div>
                </div>
              </div>

              {/* Remaining Badge */}
              <div className="wallet-badge">
                {activePlan.remainingLeads || 0} Left
              </div>
            </div>
          </div>


          <div className="header-icon-btn-wrap" ref={notifRef}>
            <div
              className="header-icon-btn"
              onClick={() => {
                setShowNotif((prev) => {
                  const next = !prev;
                  if (next) fetchNotifications();
                  return next;
                });
              }}
              role="button"
            >
              <FiBell />
              {unreadCount > 0 && (
                <span className="notification-badge">
                  {unreadCount > 99 ? "99+" : unreadCount|| 0}
                </span>
              )}
            </div>

            {showNotif && (
              <div className="notif-dropdown-panel">
                <div className="notif-dropdown-head">
                  <div>
                    <h6>Notifications</h6>
                    <span>{unreadCount} unread</span>
                  </div>
                  {unreadCount > 0 && (
                    <button onClick={handleMarkAll}><FiCheck /> All</button>
                  )}
                </div>

                <div className="notif-dropdown-list">
                  {notifications.length === 0 ? (
                    <div className="notif-dropdown-empty">
                      <FiInbox />
                      <p>No notifications</p>
                    </div>
                  ) : (
                    notifications.map((n) => {
                      const id = n._id || n.id;
                      return (
                        <div
                          key={id}
                          className={`notif-dropdown-item ${n.isRead ? "read" : "unread"}`}
                          onClick={() => handleMarkRead(id)}
                        >
                          <div className="notif-dd-icon"><FiBell /></div>
                          <div className="notif-dd-content">
                            <h6>{n.title || "Notification"}</h6>
                            <p>{n.message || "No message"}</p>
                            <small>
                              {n.createdAt ? new Date(n.createdAt).toLocaleString() : "—"}
                            </small>
                          </div>
                          {!n.isRead && <span className="notif-dd-dot" />}
                        </div>
                      );
                    })
                  )}
                </div>

                <div className="notif-dropdown-footer">
                  <button
                    onClick={() => {
                      navigate("/all-notification-list");
                      setShowNotif(false);
                    }}
                  >
                    View All Notifications →
                  </button>
                </div>
              </div>
            )}
            
          </div>
          <div className="profilie">
            <div className="d-flex align-items-center gap-2 ">
              <div className="profileimage">
                {/* <img src={`${process.env.PUBLIC_URL}/assets/images/avatar-1.jpg`} alt="Avatar" /> */}
                <img src={a2only} alt="" />
              </div>
              <div className="dropdown" ref={dropdownRef}>
                <button
                  type="button"
                  className="dropdown-toggle d-flex align-items-center gap-2"
                  onClick={profile}
                >
                  <span className="d-none d-md-block">
                    {adminData?.name}
                  </span>
                </button>
                {dropdown && (
                  <div className="custom-dropdown">

                    <div className="dropdown-header">
                      <img
                        src={a2only}
                        alt="user"
                        className="user-avatar"
                      />
                      <div>
                        <h6>{adminData?.name}</h6>
                        <span>{adminData?.email}</span>
                      </div>
                    </div>
                    <div className="dropdown-divider"></div>
                    <button
                      className="dropdown-btn"
                      onClick={() => {
                        navigate("/profile");
                      }}
                    >
                      <FiUser />
                      <span>My Profile</span>
                    </button>
                    {role === "admin" && (
                      <button
                        className="dropdown-btn"
                        // onClick={() => navigate("/change-status")}
                        onClick={() => {
                          dispatch(
                            openModal({
                              type: "change-password",
                              title: "Change Password",
                              data: null,
                            })
                          );

                          setDropdown(false);
                        }}
                      >
                        <FiSettings />
                        <span>Change Password</span>
                      </button>
                    )}


                    <div className="dropdown-divider"></div>

                    <button
                      className="dropdown-btn logout-btn"
                      onClick={handleLogout}
                    >
                      <FiLogOut />
                      <span>Logout</span>
                    </button>

                  </div>
                )}
              </div>

              {/* <div className="arrowprofile">
                                <IoIosArrowDown />
                            </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
